// extracted by css-extract-rspack-plugin
export default {"SearchContainer":"Search-module__SearchContainer__KlhojS3"};